import React, {createContext, useContext, useState, useEffect} from 'react';
import {auth, db} from '../config/firebase';
import {doc, getDoc} from 'firebase/firestore';
import {registerFCMToken} from '../utils/fcmUtils';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authLoading, setAuthLoading] = useState(true); // true hasta que Firebase resuelva
    const [userId, setUserId] = useState(null);
    const [userName, setUserName] = useState(null); // <- nuevo

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                setIsAuthenticated(true);
                setUserId(user.uid);
                // fetch userName una sola vez al autenticarse (evita N llamadas en cada componente)
                try {
                    const snap = await getDoc(doc(db, 'users', user.uid));
                    if (snap.exists()) {
                        setUserName(snap.data().userName || null);
                        // Registrar token FCM — no bloquea el flujo de auth
                        const accepted = snap.data().notificationsAccepted || false;
                        registerFCMToken(user.uid, accepted).catch(() => {});
                    }
                } catch (_) {}
            } else {
                setIsAuthenticated(false);
                setUserId(null);
                setUserName(null);
            }
            setAuthLoading(false); // auth ya resuelta
        });
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        try {
            await auth.signOut();
            setIsAuthenticated(false);
            setUserId(null);
       } catch (error) {
            console.error("Error al cerrar sesión:", error.message);
       }
   };

    return (
        <AuthContext.Provider value={{
            isAuthenticated,
            authLoading,
            userId,
            userName,
            handleLogout,
        }}>
            {children}
        </AuthContext.Provider>
    );
};